import * as React from 'react';
import {useGetRecentTopicQuery} from "../../types.d";
import {Field} from "@intelingu/core/components/form/Field";
import {HiddenField} from "./form/elements/HiddenField";
import Helpers from "@intelingu/core/helpers/Helpers";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import {useState} from "react";

interface RecentTopicProps {
    translationLanguage: number;
    sourceLanguage: number;
    cardId: number;
    rank: number;
}

export const RecentTopic = (
    { translationLanguage, sourceLanguage, cardId, rank }: RecentTopicProps
) => {
    const [topicModalVisible, setTopicModalVisible] = useState(false);

    const topic = useGetRecentTopicQuery({
        variables: {
            translationLanguage,
            sourceLanguage,
            cardId,
            rank
        }
    });

    if (!topic.data) {
        return null;
    }

    const { recentTopic } = topic.data;

    if (!recentTopic.topic) {
        return <div className="no-recent-topic">NO GRAMMAR TOPIC YET. Please use this field for another relevant (ordinary) usage of the vocabulary.</div>;
    }

    return <div className="card">
        <Field
            name={'topic'}
            render={props => (
                <HiddenField {...props} data={recentTopic.topic.id} />
            )} />

        <Field
            name={'explanation'}
            render={props => (
                <HiddenField {...props} data={recentTopic.explanation.id} />
            )} />

        <div className="card-body">
            <h4 className="card-title">recent Explanation Card</h4>
            <p dangerouslySetInnerHTML={{
                __html: recentTopic.explanation.explanationRules
            }} />

            <a href="" onClick={e => {
                e.preventDefault();
                setTopicModalVisible(true);
            }}>
                See complete Grammar Topic ({ recentTopic.topic.title })
            </a>

            <h4 className="card-title mt-4">related Mnemo Enhancers</h4>
            { recentTopic.cards.map(card => (
                <p key={card.id} dangerouslySetInnerHTML={{
                    __html: card.exampleSentence2
                }} />
            )) }
        </div>

        <Modal isOpen={topicModalVisible} className={'large-modal'} toggle={() => setTopicModalVisible(!topicModalVisible)}>
            <ModalHeader toggle={() => setTopicModalVisible(false)}>Topic Block Overview: { topic.data.recentTopic.topic.title }</ModalHeader>
            <ModalBody>
                <h4>Description</h4>
                <div dangerouslySetInnerHTML={{
                    __html: topic.data.recentTopic.topic.description
                }} />
            </ModalBody>
        </Modal>
    </div>
};
